import { __assign } from "tslib";
import React, { useContext } from 'react';
import { getComponentName } from './helpers';
export var MatureContext = React.createContext(false);
MatureContext.displayName = 'MatureContext';
// HOC for convenience...
export function withMatureContext(Component) {
    var DecoratedComponent = function (props) {
        var showMatureContent = useContext(MatureContext);
        return React.createElement(Component, __assign({ showMatureContent: showMatureContent }, props));
    };
    DecoratedComponent.displayName = "withMatureContext(".concat(getComponentName(Component), ")");
    return DecoratedComponent;
}
//# sourceMappingURL=MatureContext.js.map